export const chats = {
  chatListChatIfoAttachmentsText: 'Anexo(s) enviado(s)',
  chatListChatNoMessagesText: 'Ainda não há mensagens',
  chatArchivedTitle: 'Chats arquivados',
  chatsCreatePrivateCurtainTitle: 'Novo chat',
  chatsCreatePrivateCurtaiSearchInputPlaceholder: 'Buscar',
  chatsCreatePrivateCurtainCreateButtonTitle: 'Criar',
  chatCreateButtonTitle: 'Próximo',
  chatCreateNewGroupHeader: 'Novo grupo',
  chatGroupNameInputTitle: 'Nome do grupo',
  chatLogoTitle: 'Editar',
  chatCreateGroupButtonTitle: 'Criar grupo',
  chatRequiredFieldsAlert: 'O nome do grupo deve ser especificado!',
  chatsCreateGroupChatLongTitleAlertText: 'Por favor, use um título mais curto!',
  chatsCreateGroupChatLBigImageAlertText: 'Por favor, escolha uma imagem menor!',
  chatsNewChatInputPlaceholder: 'Escreva uma mensagem',
  chatsNewChatAddedBigImageAlertText: 'Por favor, escolha uma imagem menor!',
  chatOwnersArchiveOptionText: 'Arquivar',
  chatOwnersEditGroupOptionText: 'Editar',
  chatOwnersManageGroupOptionText: 'Gerenciar membros',
  chatOwnersChangeGroupOptionText: 'Trocar proprietário do grupo',
  chatOwnersLeaveGroupOptionText: 'Sair',
  chatOwnersDeleteGroupOptionText: 'Excluir chat',
  chatpopupArchivedTitle: 'Arquivar Chat',
  chatpopupArchivedDescription: 'Tem certeza?',
  chatArchiveGroupButtonTitleYes: 'Confirmar',
  chatArchiveGroupButtonTitleCancel: 'Cancelar',
  chatEditGroupHeader: 'Editar chat',
  chatEditGroupEditLogoTitle: 'Editar',
  chatEditGroupButtonTitle: 'Salvar',
  chatGroupEditAlertText: 'Salvo com sucesso!',
  chatManageGroupHeader: 'Gerenciar',
  chatManageGroupButtonTitle: 'Adicionar membro',
  chatManageGroupSaveButtonTitle: 'Salvar',
  chatAddUsersGroupHeader: 'Adicionar membros',
  chatAddUsersGroupButtonTitle: 'Confirmar',
  chatAddUsersGroupSearchInputPlaceholder: 'Buscar',
  chatOwnershipTransferHeader: 'Transferir propriedade',
  chatOwnershipTransferSearchInputPlaceholder: 'Buscar',
  chatOwnershipTransferButtonTitle: 'Confirmar',
  chatOwnerMarkText: '(você)',
  chatOwnershipTransferAlertText: 'Propriedade transferida!',
  chatOwnerLeaveGroupTitle: 'Sair do grupo',
  chatOwnerLeaveGroupDescription:
    'Você é o proprietário do chat, então você precisa escolher um novo proprietário antes de sair do grupo.',
  chatOwnerLeaveGroupButtonTitleYes: 'Escolher',
  chatOwnerLeaveGroupButtonTitleNo: 'Cancelar',
  chatsGroupChatUsersCurtanArchOptionTitle: 'Arquivar',
  chatsGroupChatUsersCurtanMembersOptionTitle: 'Membros do chat',
  chatsGroupChatUsersCurtanLeaveOptionTitle: 'Sair',
  chatsGroupChatMemberCurtainTitle: 'Membros do chat',
  chatsGroupChatMemberCurtainSearchInputPlaceholder: 'Buscar',
  chatsGroupChatMemberCurtainOwnerMarkText: '(proprietário)',
  chatsGroupChatLeavePopupTitle: 'Sair',
  chatsGroupChatLeavePopupText: 'Tem certeza?',
  chatsGroupChatLeavePopupCancelButtonTitle: 'Cancelar',
  chatsGroupChatLeavePopupConfirmButtonTitle: 'Confirmar',
  chatDeleteGroupTitle: 'Excluir chat',
  chatDeleteGroupDescription: 'O chat e seu histórico serão excluídos para todos os participantes, continuar?',
  chatDeleteGroupButtonTitleYes: 'Confirmar',
  chatDeleteGroupButtonTitleNo: 'Cancelar',
  chatsPrivateChatCurtainArchOptionTitle: 'Arquivar',
  chatsEditMessage: 'Editar mensagem',
  chatsCopyMessage: 'Copiar mensagem',
  chatsDeleteMessage: 'Excluir mensagem',
  chatsSelectMessage: 'Selecionar mensagem',
  chatMarkTextEdit: '(editado)',
  chatCopyMessageAlertText: 'Mensagem copiada!',
  chatDeleteMessageTitle: 'Excluir mensagem',
  chatDeleteMessageDescription: 'Excluir esta mensagem?',
  chatDeleteMessageButtonTitleYes: 'Confirmar',
  chatDeleteMessageButtonTitleNo: 'Cancelar',
  chatSelectButtonDelete: 'Cancelar',
  chatSelectButtonNo: 'Excluir',
  chatDeleteMessagesTitle: 'Excluir mensagens',
  chatDeleteMessagesDescription: 'Excluir estas mensagens?',
  chatDeleteMessagesButtonTitleYes: 'Confirmar',
  chatDeleteMessagesButtonTitleNo: 'Cancelar',
  chatArchiveButtonRestore: 'Restaurar',
  chatArchiveButtonNo: 'Excluir',
  chatNoUsersCurtainTitle: 'Ops!',
  chatsNoUsersCurtainText: 'Parece que não há outros usuários além de você. Convide amigos para começar a conversar.',
  chatsNoUsersCurtainCancelButtonTitle: 'Cancelar',
  chatsNoUsersCurtainCopyButtonTitle: 'Copiar link do aplicativo',
  chatsAppLinkCopiedAlertText: 'Link copiado!',
  chatsTooFewUsers: 'Por favor, selecione pelo menos um usuário para começar a conversar!',
  chatsError: 'Algo deu errado!'
}
